import { render, staticRenderFns } from "./StudyConversationStreamAddButton.vue?vue&type=template&id=c2124b66&scoped=true"
import script from "./StudyConversationStreamAddButton.vue?vue&type=script&lang=js"
export * from "./StudyConversationStreamAddButton.vue?vue&type=script&lang=js"
import style0 from "./StudyConversationStreamAddButton.vue?vue&type=style&index=0&id=c2124b66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2124b66",
  null
  
)

export default component.exports